'use client';

import { usePathname } from 'next/navigation';

import { Error as ErrorNotice } from '@/components';
import { PATHNAME } from '@/utils';

const {
  LOCAL: {
    CATEGORY: { BASE_URL: CATEGORY_PAGE_BASE_URL },
  },
} = PATHNAME;

type ErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function ProductError({ error, reset }: ErrorProps) {
  const pathname = usePathname();

  const isProduction =
    process.env.NODE_ENV === 'production' || pathname.startsWith('/_next');

  return (
    <ErrorNotice
      heading={!isProduction ? error.message : 'محصول مدنظر یافت نشد.'}
      paragraph='متاسفانه، محصولی که به دنبال آن هستید در حال حاضر در دسترس نمی‌باشد. از دسته‌بندی‌های سایت برای یافتن محصول مشابه استفاده کنید'
      actionTitle='دسته‌بندی‌ها'
      actionHref={CATEGORY_PAGE_BASE_URL}
      resetAction={reset}
    />
  );
}
